export const CANNOT_UNARCHIVE_PROJECT_MODAL_NAME = 'CANNOT_UNARCHIVE_PROJECT_MODAL';

export type UnarchiveProjectModalData = { organizationName: string };
